import React from 'react';
import Link from 'next/link';
import TabLinkStyles from './styles';

const Tab = (props) => {
    return (
        <TabLinkStyles isActive={props?.isActive}>
            {props.href && <Link href={props.href}>{props?.children}</Link>}
            {props.onClick && <div onClick={props.onClick}>{props?.children}</div>}
        </TabLinkStyles>
    );
};

export default Tab;
